import Vue from 'vue'
import i18n from 'vue-i18n'

import Button, { ButtonStruct } from './buttons'
import { ButtonTypes } from './buttons/types'
import { AvailableButtonsTypes } from './types'

export default class ButtonsManager {
  private i18n: i18n
  buttons: { [key: string]: Button } = {}

  firstButton: null | Button = null

  itemsList: ButtonsListItems = []

  availableButtonsTypes: AvailableButtonsTypes = []

  constructor(items: AvailableButtonsTypes, i18n: i18n) {
    this.i18n = i18n

    this.availableButtonsTypes = items

    const groups = items.filter((i) => !(i instanceof Button))

    this.itemsList.push(...groups)

    if (items.filter((i) => i instanceof Button).length) {
      this.itemsList.push({
        name: groups.length ? i18n.t('other').toString() : '',
        buttons: items.filter((i) => i instanceof Button) as Array<Button>
      })
    }

    items.forEach((item) => {
      if (item instanceof Button) {
        this.buttons[item.name] = item

        if (!this.firstButton) {
          this.firstButton = item
        }
      } else {
        item.buttons.map((b) => this.buttons[b.name] = b)
      }
    })
  }

  private get builders(): Array<Button> {
    return Object.values(this.buttons)
  }

  get soloButton(): boolean {
    return Object.values(this.buttons).length === 1
  }

  get soloSetupView(): typeof Vue {
    return Object.values(this.buttons)[0].setupView
  }

  get soloData(): unknown {
    return Object.values(this.buttons)[0].data
  }

  get soloProps(): { [key: string]: any } | null {
    return Object.values(this.buttons)[0].propsData
  }

  getButtonIcon(type: string): string | null {
    const builder = this.getButton(type)

    if (builder) {
      return builder.icon
    }
    return null
  }

  soloCreate(): ButtonStruct {
    return Object.values(this.buttons)[0].create()
  }

  refreshData(): void {
    this.builders.forEach((builder) => builder.refreshData())
  }

  getButtonView(type: ButtonTypes): typeof Vue {
    return this.buttons[type]?.buttonView
  }

  getSetupView(type: ButtonTypes): { component: typeof Vue, props: { [key: string]: any } | null } {
    return {
      component: this.buttons[type]?.setupView,
      props: this.buttons[type]?.propsData
    }
  }

  getButton(type: string): Button {
    return this.buttons[type]
  }
}

type ButtonsListItems = Array<Button | ButtonGroup>

type ButtonGroup = {
  name: string
  buttons: Array<Button>
}
